import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';

import { useAuthState } from "react-firebase-hooks/auth";
import { useList } from 'react-firebase-hooks/database';
import { Redirect, useHistory } from "react-router";
import "./Dashboard.css";
import { auth, db, logout } from "./firebase";

import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { Form, Field } from 'react-final-form';

import Stack from '@mui/material/Stack';


import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import { Icon } from "@material-ui/core";



import UserInfo from './UserInfo';
import Client from './Client';
import ClientDevices from "./ClientDevices";

//import useWindowScroll from "@react-hook/window-scroll";

import { useSpring, animated } from 'react-spring'


import Styles from './Styles';

import {styled} from "@mui/system";

import { useTheme, useMediaQuery } from '@material-ui/core';


function ClientDetail(props) {
  const theme = useTheme();
  const isLG = useMediaQuery(theme.breakpoints.up('lg'));
  const isSM = useMediaQuery(theme.breakpoints.up('sm'));
  //const [user, loading_user, error] = useAuthState(auth);
  const location = useLocation();

  const history = useHistory();

  const [devices, setDevices] = useState([]);
  const [deviceNumber, setDeviceNumber] = useState(0);
  const [selectedDevice, setSelectedDevice] = useState();
  const [selectedDeviceName, setSelectedDeviceName] = useState();

  const [openAdd, setOpenAdd] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [isPowerUser, setIsPowerUser] = useState(false);

  const [clientInfo, setClientInfo] = useState();


  const uid = location.state.uid;

  const r = '/clients/' + uid + '/devices';

  const [devices_snapshot, loading_devices, error_db] = useList(db.ref(r));

  /*
  const [flip, set] = useState(false)
  const props = useSpring({
    to: { opacity: 1 },
    from: { opacity: 0 },
    reset: true,
    reverse: flip,
    delay: 200,
    onRest: () => set(!flip),
  }) */

  const LinkButton = styled(Button)({
    textTransform: 'none',
  });

  useEffect(() => {
    setIsPowerUser((sessionStorage.getItem("power_user")=='true') || (sessionStorage.getItem("admin")=='true'));
    if(devices_snapshot && !loading_devices)
    {
      const dv = [];
      devices_snapshot.map(device => {
        //console.log(device.key + " :: " + device.val());
        dv.push({
          id: device.key,
          info: device.val()
        })
      })
      setDevices(dv);
    }
  }, [devices_snapshot, loading_devices]);

  const getDeviceList = () =>
  {
    const device_data = [];
    devices_snapshot.map(device => {
      //console.log(device.key);
      //console.log(device.val().current_status.pressures.p1.value);
      device_data.push(
        {
          id: device.key,
          title: device.val().title,
          client: device.val().client,
          current_status: device.val().current_status,
          status: device.val().status,
        }
      );
    })
    setDevices(device_data);
    console.log(devices);
  }


  if (loading_devices)
  {
    return (<div style={{alignItems: "center", display: 'flex', justifyContent: 'center', height: "100vh", width: "100vw" }}>
            <Box sx={{ display: 'flex' }}>
              <Typography variant="caption" style={{textAlign: "center"}} component="div" color="text.secondary">
                <CircularProgress /><br />
                Loading LPG devices...
              </Typography>
            </Box>
            </div>);
  }


  const onSubmit = async values => {
   
}

const getClientInfo_callback = (clientInfo) => {
  setClientInfo(clientInfo);
  console.log(clientInfo)
}

const updateDevice = (deviceId) => {
    history.push(
        { pathname: '/update_device',
          state: {
              deviceId: deviceId,
          }
        });
}

const deleteDevice = () => {
  //console.log("Post start datetime:: " + moment(startDateTime).format("YYYY-MM-DD HH:mm:ss"));
  //console.log("Post end datetime:: " + moment(endDateTime).format("YYYY-MM-DD HH:mm:ss"));
}

const handleDelete = (id, name) => {
    setSelectedDevice(id);
    setSelectedDeviceName(name);
    setOpenDelete(true);
}

const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };

const handleCloseAdd = () => {
    setOpenAdd(false);
  };

const handleCloseDelete = () => {
    setOpenDelete(false);
  };

const showClients = () => {
    history.push(
        { 
          pathname: '/clients',
        });
  }

  return (
    <div className="container">  
            <Container maxWidth="lg" >
                <Grid container spacing={2} sx={{pt: 12, pl:2, pr:2, pb:2}}>
                   <Grid item xs={12}>
                      <Card>
                        <CardContent>
                          <Typography variant="h6" component="div">
                            <Stack direction="row" spacing={1}>
                              <Typography variant="h6">Client Detail </Typography>
                            </Stack>
                          </Typography>
                          {isPowerUser ? (<Typography sx={{ mb: 1.5 }} color="text.secondary">
                            Admin/Power User mode only
                          </Typography>):(<div/>)}
                          <Typography variant="body2">
                            Client detail for administrative purpose only.
                          </Typography>
                        </CardContent>
                        <CardActions>
                          <Button onClick={showClients}>Back to Clients List</Button>
                        </CardActions>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <UserInfo uid={uid} />
                    </Grid>
                    <Grid item xs={12}>
                      <Client uid={uid} />
                    </Grid>
                    <Grid item xs={12}>
                      <ClientDevices uid={uid} />
                    </Grid>
                </Grid>
                
                <Dialog
                    open={openDelete}
                    onClose={() => handleCloseDelete}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    >
                    <DialogTitle id="alert-dialog-title">
                        {"Delete device??"}
                        </DialogTitle>
                        <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Delete device #{selectedDevice} with title "{selectedDeviceName}" from database? This cannot be undone.
                        </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={handleCloseDelete}>Cancel</Button>
                        <Button color="error" onClick={deleteDevice} autoFocus>
                            Delete
                        </Button>
                        </DialogActions>
                    </Dialog>
                    <Grid container spacing={2} sx={{p: 4}}>
                    <Grid item xs={12}></Grid> 
                </Grid>
            </Container>
    </div>
  );
}

export default ClientDetail;
